const PAID = 'paid'
const PENDING = 'pending'
const FAILED = 'failed'
const ASSIGNED = 'assigned'

const STATUS_READING = [PAID, PENDING, FAILED]

const STATUS_READING_COLOR = {
    [PAID]: 'success',
    [PENDING]: 'warning',
    [FAILED]: 'danger',
    [ASSIGNED]: 'info',
}
const meterReadingStatus = {
    PAID,
    PENDING,
    FAILED,
    ASSIGNED,
    STATUS_READING,
    STATUS_READING_COLOR,
}

export default meterReadingStatus
